import type { GameRow } from '../types';
import type { UsGamePropTarget } from '@/lib/polymarketUs/gamePropTarget';
import { usGamePropFamily } from '@/lib/polymarketUs/gamePropFamily';
export function usGamePropPanelGame(base: GameRow, target: UsGamePropTarget, title?: string | null): GameRow {
  const caption = title ?? usGamePropFamily(target.sportsMarketType, base.sport.toUpperCase())?.label ?? 'US game contract';
  return { ...base, key: `${base.key}|us-game-prop|${target.marketSlug}`, usGameProp: target,
    awayName: caption, homeName: caption, kalshi: null, polymarket: null, spreadOutcome: undefined, finalWinnerSide: null };
}
